import store from '@/store'

const PermissionPlugin = {
    install(Vue) {
        Vue.prototype.$hasPrivilegeView = function(privilegeCode: string) {
            // Available for all user
            if (privilegeCode === 'ALL_USER') {
                return true
            }
            if (store.state.auth.authInfo.privileges) {
                return store.state.auth.authInfo.privileges.find((item: any) => item.code === privilegeCode)
            }
            return false
        }
    }
}

export default PermissionPlugin
